import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from 'src/app/core/services/shared.service';
import { VendorService } from 'src/app/core/services/vendor.service';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-statutory-compliance-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MaterialModule],
  templateUrl: './statutory-compliance-dialog.component.html',
  styleUrl: './statutory-compliance-dialog.component.scss',
})
export class StatutoryComplianceDialogComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  private vendorservice = inject(VendorService);
  private sharedService = inject(SharedService);
  private domsanitizer = inject(DomSanitizer);
  dialogRef = inject<MatDialogRef<StatutoryComplianceDialogComponent>>(MatDialogRef);

  sanitizedData: any;

  ngOnInit() {
    console.log(this.data);
  }

  onAccept() {
    const saveObj = {
      companyCode: this.data.companyCode,
      flag: '0',
    };
    this.vendorservice.saveStatutoryCompliance(saveObj).subscribe(
      (response) => {
        console.log(response);
        if (response.status == 1) {
          const info = {
            msg: response?.message,
            isSuccess: true,
          };
          this.sharedService.openSnackBar(info, 'success-snack');
          this.dialogRef.close(true);
        } else {
          const info = {
            msg: response?.message,
            isSuccess: false,
          };
          this.sharedService.openSnackBar(info, 'success-snack');
          this.dialogRef.close(false);
        }
      },
      (err) => {
        if (err) {
          const info = {
            msg: 'Technical error occured, please try again later',
            isSuccess: false,
          };
          this.sharedService.openSnackBar(info, 'success-snack');
          this.dialogRef.close(false);
        }
      },
    );
  }
}
